import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { quizProgressActions } from '../actions/quiz-progress.actions';
import { QuizProgressHttpService } from '../services/http.service';

@Injectable({
    providedIn: 'root',
})
export class QuizProgressEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(QuizProgressHttpService);

    getProgress$ = createEffect(() => {
        return this.actions.pipe(
            ofType(quizProgressActions.getProgress),
            mergeMap(({ quizId }) =>
                this.httpService.getProgress(quizId).pipe(
                    map((payload) => quizProgressActions.getProgressSuccess({ payload })),
                    catchError((error: HttpErrorResponse) => {
                        if (error.status === 404) {
                            return of(quizProgressActions.getProgressNotStarted({ quizId }));
                        }
                        return of(quizProgressActions.getProgressError({ quizId, code: error.status }));
                    }),
                ),
            ),
        );
    });

    saveAnswer$ = createEffect(() => {
        return this.actions.pipe(
            ofType(quizProgressActions.saveAnswer),
            mergeMap(({ quizId, questionId, optionId }) =>
                this.httpService.saveAnswer(quizId, questionId, optionId).pipe(
                    map((payload) => quizProgressActions.saveAnswerSuccess({ payload })),
                    catchError((error: HttpErrorResponse) => of(quizProgressActions.saveAnswerError({ quizId, code: error.status }))),
                ),
            ),
        );
    });

    retry$ = createEffect(() => {
        return this.actions.pipe(
            ofType(quizProgressActions.retry),
            mergeMap(({ quizId }) =>
                this.httpService.retry(quizId).pipe(
                    map(() => quizProgressActions.retrySuccess({ quizId })),
                    catchError((error: HttpErrorResponse) => of(quizProgressActions.retryError({ quizId, code: error.status }))),
                ),
            ),
        );
    });
}
